import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
    addEdPresentations,
  addPlaylist,
  addPlaylistType,
  getBrands,
  getLanguages,
  getOutletTags,
  getPlaylist,
  getPlaylistType,
  getPresentations,
  getPresentationsDopdown,
  getPresentationType,
  updateEdPresentations,
  updatePlaylist,
  updatePlaylistType,
} from "../repository/EdetailingRepository";
import { toast } from "react-toastify";
import { showToast } from "../../../utils/toastUtils";


interface ReqBodyInterace {
  PlaylistName: string;
  PlaylistTypeId: number;
  OrgunitId: number;
  Presentations: string[];
  PlaylistVersionId: number;
  OutletTags: string[];
  PlaylistMedia: number;
}


// Fetch playlist hook
export const usePlaylistTypeData = ({params = {},enable = false,}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["PLAYLIST_TYPE",params],
    queryFn: () => getPlaylistType(params),
    enabled: enable,
    retry: false,
  });
};

export const usePresentationDrowDown = ({params = {},enable = false,}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["ED-PRESENTATIONS",params],
    queryFn: () => getPresentationsDopdown(params),
    enabled: enable,
    retry: false,
  });
};






export const useAddPlayListType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addPlaylistType,
    onSuccess: (data) => {
      showToast.success("Playlist Type Added Successfully!");
      queryClient.invalidateQueries({ queryKey: ["PLAYLIST_TYPE"] });
    },
    onError: (error) => {
      showToast.warning("Failed to Add Playlist Type!");
    },
  });
};
export const useUpdatePlayListType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({id,body,}: {
      id: number;
      body: { PlaylistTypeName: string };
    }) => updatePlaylistType(id, body),
    onSuccess: (data) => {
      showToast.success("Update Playlist Type Added Successfully!");
      queryClient.invalidateQueries({ queryKey: ["PLAYLIST_TYPE"] });
    },
    onError: (error) => {
      showToast.warning("Failed to Add Playlist Type!");
    },
  });
};


// Fetch presentation hook
export const usePresentationData = ({params = {},enable = false,}: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
      queryKey: ["PRESENTATIONS",params],
      queryFn: () => getPresentations(params),
      enabled: enable,
      retry: false,
    });
  };

  export const useAddEdPresentations = () => {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: addEdPresentations,
      onSuccess: (data) => {
        showToast.success("EdPresenation Added Successfully!");
        queryClient.invalidateQueries({ queryKey: ["PRESENTATIONS"] });
      },
      onError: (error) => {
        showToast.warning("Failed to Add EdPresenation!");
      },
    });
  };
  export const useUpdateEdPresentations = () => {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: ({id,body,}: {
        id: any;
        body:any;
      }) => updateEdPresentations(id, body),
      // mutationFn: updateEdPresentations,
      onSuccess: (data) => {
        showToast.success("EdPresenation Update Successfully!");
        queryClient.invalidateQueries({ queryKey: ["PRESENTATIONS"] });
      },
      onError: (error) => {
        showToast.warning("Failed to Update EdPresenation!");
      },
    });
  };

  ///////////////////EdPresentations end/////////////////

// Fetch playlist hook
export const usePlaylistData = ({params = {},enable = false,}: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
      queryKey: ["PLAYLIST",params],
      queryFn: () => getPlaylist(params),
      enabled: enable,
      retry: false,
    });
  };

  export const useAddPlaylist = () => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn:(ReqBody:any)=>addPlaylist(ReqBody),
      onSuccess: (data) => {
        showToast.success("PLAYLIST Added Successfully!");
        queryClient.invalidateQueries({ queryKey: ["PLAYLIST"] });
      },
      onError: (error) => {
        showToast.warning("Failed to Add PLAYLIST!");
        console.log('Faled to Add Add PlayList')
      },
    });
  };
  export const useUpdatePlaylist = () => {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn:(ReqBody:any)=> updatePlaylist(ReqBody),
      onSuccess: (data) => {
        showToast.success("PLAYLIST Update Successfully!");
        queryClient.invalidateQueries({ queryKey: ["PLAYLIST"] });
      },
      onError: (error) => {
        showToast.warning("Failed to Update PLAYLIST!");
      },
    });
  };


  /////////////////playlist end//////////////////////


  export const useGetBrandData = ({ enable = false }: { enable?: boolean } = {}) => {
      return useQuery({
          queryKey: ["GET_BRAND_DATA"],
          queryFn: getBrands,
          enabled: enable,
          retry: false
      });
  };
  export const useGetPresentationTypeData = ({ enable = false }: { enable?: boolean } = {}) => {
      return useQuery({
          queryKey: ["GET_PRESENTATION_TYPE_DATA"],
          queryFn: getPresentationType,
          enabled: enable,
          retry: false
      });
  };
  export const useGetLanguagesData = ({ enable = false }: { enable?: boolean } = {}) => {
      return useQuery({
          queryKey: ["GET_LANGUAGES_DATA"],
          queryFn: getLanguages,
          enabled: enable,
          retry: false
      });
  };
  export const useGetOutletTagsData = ({ enable = false }: { enable?: boolean } = {}) => {
      return useQuery({
          queryKey: ["GET_OUTLET_DATA"],
          queryFn: getOutletTags,
          enabled: enable,
          retry: false
      });
  };
